import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { StandardHomeEquityOffer } from 'components/Offers/StandardHomeEquityOffer/StandardHomeEquityOffer';
import PageLoadingMask from 'components/masks/PageLoadingMask';

const HomeEquityOffersView = props => {
  if (props.homeEquityOffersLoading) {
    return <PageLoadingMask />;
  } else {
    return (
      <Row>
        <StaticOfferContainer
          homeLoanTemplate={StandardHomeEquityOffer}
          offerMetadataList={props.homeEquityOffers}
          pagePosition={props.pagePosition}
          eventHandler={props.eventHandler}
          datatestid={props.datatestid}
          {...props}
        />
      </Row>
    );
  }
};

const HomeEquityMarketplaceModuleView = props => {
  return (
    <SectionContainer className="HomeEquityOfferContainer">
      <Row>
        <Label
          datatestid={`${props.datatestid}-offers-title`}
          type="H3"
          typeHeader={'h3'}
          className="margB32"
        >
          Explore home equity options
        </Label>
      </Row>
      <HomeEquityOffersView
        homeEquityOffers={props.homeEquityOffers}
        datatestid={props.datatestid}
        {...props}
      />
    </SectionContainer>
  );
};

export default HomeEquityMarketplaceModuleView;
